import styled from "styled-components";

export const Page404Styled = styled.div`
	width: 100%;
	height: 100%;

	padding-top: 6rem;

	.card {
		display: flex;
		flex-direction: column;

		.btn {
			margin: 0 0 2rem 2rem;

			.arrow-left {
				width: 5rem;
				transition: all 0.3s ease;

				cursor: pointer;

				&:hover {
					scale: 1.01;
					filter: drop-shadow(2px 0 5px var(--color-gray-7));
				}
			}
		}

		.text {
			margin-top: 3rem;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			row-gap: 3rem;

			img {
				width: 30rem;
			}

			h1 {
				color: var(--color-white-fixed);
				font-weight: var(--fw-bold);
				font-size: 30pt;
			}
		}
	}
`;
